import Choices from "choices.js";

export function isMobile() {
    return window.innerWidth < 1000;
}

export function isTablet() {
    return window.innerWidth > 760;
}

export function isDesktop() {
    return window.innerWidth > 1000;
}

export function scale(block) {
    let step = 0.1;
    let minfs = 2;
    let scw = block.scrollWidth;
    let w = block.offsetWidth;

    if (scw > w) {
        let fontsize = 100 * (parseInt($(block).css('font-size'), 10)) / window.innerWidth - step;
        if (fontsize >= minfs) {

            $(block).css('font-size', `${fontsize}vw`)
            scale(block);
        }
    }
}

/**
 * Форматирования числа в денежный формат
 * @param {Number} number - число для форматирования
 * @param {Number} decimals - знаков после запятой
 * @param {String} decPoint - разделитель для float
 * @param {String} thousandsSep - разделить разрядов
 * @returns {string} число в денежном формате
 */
export function numberFormat(number, decimals = 0, decPoint = '', thousandsSep = ' ') {
    let i,
        j,
        kw,
        kd,
        km;

    i = parseInt(number = (+number || 0).toFixed(decimals)) + '';
    if ((j = i.length) > 3) {
        j = j % 3;
    } else {
        j = 0;
    }
    km = (j ? i.substr(0, j) + thousandsSep : '');
    kw = i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousandsSep);
    kd = (decimals ? decPoint + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : '');
    return km + kw + kd;
}

export function showModal($modal){
    $modal.addClass('fade-in-show');
    $('.modal-window-pxl').addClass('open-modal');
    setTimeout(() => {
        $('.modal-window-pxl').addClass('open-modal-fade-effect');
    }, 50);

    $('html').css('overflow', 'hidden');
}

export function hideModal($modalClose){
    const $currentModal = $modalClose.parents('.modal-window');

    if(!$currentModal.hasClass('sizes-modal')){
        $currentModal.find('.success .product-block').html('');
    }

    $currentModal.removeClass('fade-in-show');
    $('.modal-window-pxl').removeClass('open-modal-fade-effect');
    setTimeout(() => {
        $('.modal-window-pxl').removeClass('open-modal');
    }, 400);

    $('html').css('overflow', 'auto');
}

export function renderModalContent(payload, productData, productType) {
    const $cartModal = $('#cart_modal');

    const customShirtImg = $('[data-slide-with-custom-shirt] img').attr('src')
        || productData.img?.substring(5,productData.img.length - 2)
        || $('#product-swiper img').first().attr('src');

    const currentProductPrice =  `${numberFormat(productData.price, 0, '', ' ')} ₽`;
    let productName = productData.name || $('[data-product-name]').text();

    let modalTemplate = '';
    let sizeHTML = '';

    if (productType === 'customShirt') {
        const isOptionsChecked = $('#additional_options').prop('checked');
        let customShirtModalTemplate = ``;
        let customShirtPrice = `${numberFormat($('[data-product-price]').data('product-price'),0,'',' ')} ₽`;

        //если на главной - берём из json кастомной майки
        if($('#main_page_landing').length){
            const $customShirtBlock = $('.custom-shirt');
            const customShirtNames = {...JSON.parse(JSON.stringify($customShirtBlock.data('product-info')))}

            if($('.pretty-panel').hasClass('right-position')){
                productName = customShirtNames.visit;

            }else if($('.pretty-panel').hasClass('left-position')){
                //для случая, когда доступна 1 из маек
                productName = customShirtNames.home || customShirtNames.visit;
            }
        }

        if(productData.customShirtLastName){
            customShirtModalTemplate += `
                          <div class="modal-size">
                            <span class="body-16">Фамилия:</span>
                            <span class="h5">${productData.customShirtLastName}</span>
                          </div>
                        `
        }

        if(productData.customShirtNumber){
            customShirtModalTemplate += `
                          <div class="modal-size">
                            <span class="body-16">Номер:</span>
                            <span class="h5">${productData.customShirtNumber}</span>
                          </div>
                        `
        }

        if(isOptionsChecked){
            customShirtModalTemplate += `
                          <div class="modal-size logos">
                            <span class="body-16">Логотипы:</span>
                             <span class="h5">добавлены</span>
                          </div>
                        `;
        }else{
            customShirtModalTemplate += `
                          <div class="modal-size logos">
                            <span class="body-16">Логотипы:</span>
                             <span class="h5">не добавлены</span>
                          </div>
                        `;
        }
        /*if(productData.customShirtLogos && productData?.customShirtLogos?.length !== 0){
            let logosTemplate = '';

            productData.customShirtLogos.forEach(logo => {
                logosTemplate += `${logo.logoName}, `
            });

            logosTemplate = logosTemplate.substring(0,logosTemplate.length - 2);

            customShirtModalTemplate += `
                          <div class="modal-size logos">
                            <span class="body-16">Логотипы:</span>
                            <span class="h5">${logosTemplate}</span>
                          </div>
                        `
        }*/

        modalTemplate = `
                        <h3 class="h3">Товар добавлен в корзину</h3>
                        <div class="product-modal-info">
                            <img style="width: 95px;" src="${customShirtImg}"/>
                            <div class="product-modal-info-text">
                                <div class="product-modal-info-left">
                                    <h4 class="h4">${productName}</h4>
                                    <div class="modal-size">
                                        <span class="body-16">Размер:</span>
                                        <span class="h5">${productData.sizeText}</span>
                                    </div>
                                      <div class="modal-size">
                                        <span class="body-16">Количество:</span>
                                        <span class="h5">${productData.count}</span>
                                    </div>
                                    ${customShirtModalTemplate}
                                </div>
                                <span class="modal-price h4">${customShirtPrice}</span>
                            </div>
                        </div>`;

    } else {
        let defaultProductPrice = currentProductPrice;

        if(!productData.price){
            defaultProductPrice = `${numberFormat($('[data-product-price]').data('product-price'), 0, '', ' ')} ₽`;
        }

        if(productData.sizeText){
            sizeHTML = `  <div class="modal-size">
                            <span class="body-16">Размер:</span>
                            <span class="h5">${productData.sizeText}</span>
                          </div>`;
        }

        modalTemplate = `
                        <h3 class="h3">Товар добавлен в корзину</h3>
                        <div class="product-modal-info">
                            <img src="${productData.img}"/>
                            <div class="product-modal-info-text">
                                <div class="product-modal-info-left">
                                    <h4 class="h4">${productName}</h4>
                                   ${sizeHTML}
                                     <div class="modal-size">
                                        <span class="body-16">Количество:</span>
                                        <span class="h5">${productData.count}</span>
                                    </div>
                                </div>
                                <span class="modal-price h4">${defaultProductPrice}</span>
                            </div>
                        </div>`;
    }

    $cartModal.find('.success .product-block').prepend(modalTemplate);
}

//склонение
export function getRightTerm(number, one, two, five) {
    let n = Math.abs(number);
    n %= 100;
    if (n >= 5 && n <= 20) {
        return five;
    }
    n %= 10;
    if (n === 1) {
        return one;
    }
    if (n >= 2 && n <= 4) {
        return two;
    }
    return five;
}

/**
 * Инпаты с контролем заполненности и очисткой
 */
export function initFillControlInput() {
    $('.input-fill-control').each(function () {
        const $this = $(this);
        if ($this.hasClass('fill-control-ready')) return;

        const $field = $(this).parents('.field');

        checkFilledInput($this);

        $this.on('change keyup', function () {
            checkFilledInput($this);
        });

        $field.find('.clear-input-button').on('click', function () {
            $this.val('');
            checkFilledInput($this);
        });

        $(this).addClass('fill-control-ready');
    });


    function checkFilledInput($input) {
        const filledClassName = 'filled';
        const val = $input.val();
        const $field = $input.parents('.field');
        if (val) {
            $field.addClass(filledClassName);
        } else {
            $field.removeClass(filledClassName);
        }
    }
}

export function initSelects() {
    $('select.select').each((key, item) => {
        initChoices(item);
    });

    function initChoices($element, options = {
        searchEnabled: false,
        silent: true,
        itemSelectText: '',
        allowHTML: true,
        position: 'right'
    }) {
        if (!$element) return;

        new Choices($element, options);
    }
}
//валидация на вводе пароля подтверждения
export function validateCheckPasswordInput() {
    if($('#email_code').val().length === 0){
        $('#email_code').parents('.field').addClass('empty');

    }

    if ($('#email_code').val().length !== 6) {
        $('#email_code').siblings('.error-message').text('Минимум 6 цифр');
        $('#email_code').parents('.field').removeClass('empty').removeClass('success').addClass('error');
        return false;

    }else{
        $('#email_code').siblings('.error-message').text('');
        $('#email_code').parents('.field').removeClass('empty').addClass('success').removeClass('error');
    }

    return true;
}

//получение стоимости в независимости - целое ли число или десятичное
export function getRightPrice(price){
    //если число целое - возвращаем без разделителей
    if(Number.isInteger(price)){
        return numberFormat(price,'','',' ' )

        //иначе - с копейками
    }else{
        return numberFormat(price,2,',',' ' )
    }
}